import { useState, useEffect, useCallback } from 'react';
import setedigitalApi from 'services/api/setedigitalApi';

export interface Permission {
  mapping: {
    title: string;
  };
  active: boolean;
  accessLevel: number;
}

export interface Role {
  frontendAccess: boolean;
  frontendPermissions: Permission[];
}

export interface User {
  roles: Role[];
}

export const usePermission = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loadingHook, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const response = await setedigitalApi.get("/user/me", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
      } catch (error) {
        console.error("Failed to fetch user", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  // Use o useCallback para estabilizar a referência da função
  const getAccessLevel = useCallback((mappingTitle: string) => {
    if (!user || !user.roles?.length) return 0;

    let maxAccessLevel = 0;
    for (const role of user.roles) {
      if (!role.frontendAccess) continue;
      for (const permission of role.frontendPermissions) {
        if (permission.mapping.title === mappingTitle && permission.active) {
          maxAccessLevel = Math.max(maxAccessLevel, permission.accessLevel);
        }
      }
    }
    return maxAccessLevel;
  }, [user]); // A função só será recriada se o 'user' mudar

  const hasPermission = useCallback((mappingTitle: string, requiredAccessLevel = 1) => {
    if (!user || !user.roles?.length) return false;
    const level = getAccessLevel(mappingTitle);
    return level >= requiredAccessLevel;
  }, [user, getAccessLevel]);


  return { user, loadingHook, hasPermission, getAccessLevel };
};
